import { render } from "./SokobanEditor.vue?vue&type=template&id=682844e8&scoped=true"
import script from "./SokobanEditor.vue?vue&type=script&lang=js"
export * from "./SokobanEditor.vue?vue&type=script&lang=js"

import "./SokobanEditor.vue?vue&type=style&index=0&id=682844e8&scoped=true&lang=css"

import exportComponent from "/home/jay/Code/dm-sokoban-leveleditor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-682844e8"]])

export default __exports__